export default "__VITE_ASSET__BBHncIkI__"